$(function(){
	$('.js-add').on('click', function(){
		$('.js-to-clone').first().clone().find('input').val('').end().appendTo('form');
	});
});